import { DottedWrapperStyle } from './DottedWrapper.styled';

type DottedWrapperProps = { children: React.ReactNode; size?: number };

const DottedWrapper = (props: DottedWrapperProps) => (
  <DottedWrapperStyle $size={props.size}>{props.children}</DottedWrapperStyle>
);

export default DottedWrapper;
